(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-swatches"] && !Shopify.designMode) return;
  try {
    /* Card swatches: pointing at or focusing a chip shows that variant's image in its card.
     One delegated listener serves every card, including cards added later (drawer, search). */
  (() => {
    if (window.cardSwatchesReady) return;
    window.cardSwatchesReady = true;

    const show = (event) => {
      const chip = event.target.closest?.('.card-swatches__chip[data-srcset]');
      if (!chip) return;
      const image = chip.closest('.product-card')?.querySelector('.product-card__image:not(.product-card__image--hover)');
      if (!image || image.dataset.variantSrc === chip.dataset.src) return;
      image.dataset.variantSrc = chip.dataset.src;
      image.srcset = chip.dataset.srcset;
      image.src = chip.dataset.src;
    };

    document.addEventListener('pointerover', show);
    document.addEventListener('focusin', show);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["locale-modal"] && !Shopify.designMode) return;
  try {
    class LocaleModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.filter = this.querySelector('[data-filter]');
      this.empty = this.querySelector('[data-empty]');
      this.heading = this.querySelector('#LocaleModalTitle');
      document.addEventListener('click', this.#onDocumentClick);
      this.dialog.addEventListener('click', this.#onDialogClick);
      this.dialog.addEventListener('close', this.#onClose);
      this.filter.addEventListener('input', this.#onFilter);
      this.filter.addEventListener('keydown', this.#onFilterKey);
      this.form.addEventListener('keydown', this.#onFormKey);
      this.form.addEventListener('change', this.#onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onDocumentClick);
    }

    open(mode, opener) {
      this.mode = mode === 'country' ? 'country' : 'all';
      this.opener = opener;
      this.dialog.dataset.mode = this.mode;
      this.heading.textContent = this.heading.dataset[this.mode === 'country' ? 'titleCountry' : 'titleAll'];
      this.#applyFilter('');
      if (!this.dialog.open) this.dialog.showModal();
      // the top of the list (languages first), or the current country when it sits further down;
      // the search box first where there is a keyboard
      const scroller = this.querySelector('.locale-modal__scroll');
      const current = this.form.querySelector('[name="country_code"]:checked')?.closest('li');
      const below = current && current.offsetTop + current.offsetHeight > scroller.clientHeight;
      scroller.scrollTop = below ? current.offsetTop - scroller.clientHeight / 2 : 0;
      if (window.matchMedia('(pointer: fine)').matches) this.filter.focus();
    }

    #onDocumentClick = (event) => {
      const button = event.target.closest('[data-locale-open]');
      if (!button) return;
      event.preventDefault();
      this.open(button.dataset.localeOpen, button);
    };

    #onDialogClick = (event) => {
      if (event.target === this.dialog || event.target.closest('[data-close]')) this.dialog.close();
    };

    #onClose = () => {
      this.filter.value = '';
    };

    #onFilter = () => this.#applyFilter(this.filter.value);

    #applyFilter(value) {
      this.filter.value = value;
      const query = value.trim().toLowerCase();
      let shown = 0;
      for (const item of this.querySelectorAll('li[data-terms]')) {
        const group = item.closest('[data-group]');
        const inMode = this.mode !== 'country' || group.dataset.group === 'country';
        const match = !query || item.dataset.terms.includes(query);
        item.hidden = !match;
        if (match && inMode) shown += 1;
      }
      for (const group of this.querySelectorAll('[data-group]')) {
        group.hidden = !group.querySelector('li:not([hidden])');
      }
      this.empty.hidden = shown > 0;
    }

    // Enter in the search box picks the first match still showing
    #onFilterKey = (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      const scope = this.mode === 'country' ? '[data-group="country"] ' : '';
      const first = this.form.querySelector(`${scope}li:not([hidden]) .locale-modal__radio`);
      if (!first) return;
      if (first.checked) this.#submit();
      else first.click();
    };

    // arrow keys only move through a radio list; Enter (or Space) chooses
    #onFormKey = (event) => {
      if (!event.target.matches('.locale-modal__radio')) return;
      if (event.key.startsWith('Arrow')) this.arrowing = true;
      if (event.key === 'Enter') {
        event.preventDefault();
        this.#submit();
      }
      if (event.key === ' ' && event.target.checked) this.#submit();
    };

    #onChange = (event) => {
      if (!event.target.matches('.locale-modal__radio')) return;
      if (this.arrowing) {
        this.arrowing = false;
        return;
      }
      this.#submit();
    };

    #submit() {
      // Liquid only knows the path: come back with the query too (selected variant, search terms)
      if (this.form.elements.return_to) this.form.elements.return_to.value = window.location.pathname + window.location.search;
      if (this.opener?.closest('dialog')) {
        try {
          sessionStorage.setItem('morrow:reopen-bag', '1');
        } catch {}
      }
      if (this.form.requestSubmit) this.form.requestSubmit();
      else this.form.submit();
    }
  }

  if (!customElements.get('locale-modal')) customElements.define('locale-modal', LocaleModal);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    /**
   * Replaces the browser's validation tooltip with a localised message in the form's
   * alert line, marks the field invalid and returns focus to it.
   */
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.error = this.querySelector('.newsletter-form__error');
      if (!this.form || !this.input || !this.error) return;

      this.form.noValidate = true;
      this.form.addEventListener('submit', this.#onSubmit);
      this.input.addEventListener('input', this.#onInput);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.#onSubmit);
      this.input?.removeEventListener('input', this.#onInput);
    }

    #onSubmit = (event) => {
      this.input.value = this.input.value.trim();
      if (this.input.checkValidity()) return;
      event.preventDefault();
      this.error.textContent = this.input.validity.valueMissing
        ? this.dataset.errorMissing
        : this.dataset.errorInvalid;
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
    };

    #onInput = () => {
      if (!this.input.hasAttribute('aria-invalid') || !this.input.checkValidity()) return;
      this.input.removeAttribute('aria-invalid');
      this.error.textContent = '';
    };
  }

  if (!customElements.get('newsletter-form')) customElements.define('newsletter-form', NewsletterForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    /**
   * The product image viewer. The product page calls open(mediaId, opener); the dialog
   * closes natively on Esc, and focus goes back to the opener.
   */
  class ProductLightbox extends HTMLElement {
    #opener = null;
    #loaded = false;
    #finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.list = this.querySelector('.lightbox__list');
      this.dialog.addEventListener('click', this.#onClick);
      this.dialog.addEventListener('pointermove', this.#onPointerMove);
      this.dialog.addEventListener('close', this.#onClose);
    }

    /**
     * @param {string} mediaId - The picture to show first
     * @param {HTMLElement} [opener] - Where focus returns on close
     */
    open(mediaId, opener) {
      this.#opener = opener ?? document.activeElement;
      if (!this.#loaded) {
        for (const image of this.querySelectorAll('img[data-src]')) {
          image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
        }
        this.#loaded = true;
      }
      this.dialog.showModal();
      const item = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (item) this.list.scrollTop = item.offsetTop - this.list.offsetTop;
    }

    #onClick = (event) => {
      if (event.target.closest('[data-lightbox-close]')) {
        this.dialog.close();
        return;
      }
      const image = event.target.closest('.lightbox__image');
      if (!image || !this.#finePointer.matches) return;
      const zoomed = image.classList.toggle('is-zoomed');
      if (zoomed) this.#setOrigin(image, event);
    };

    #onPointerMove = (event) => {
      const image = event.target.closest('.lightbox__image.is-zoomed');
      if (image) this.#setOrigin(image, event);
    };

    /** Zoom towards the pointer: transform-origin at the pointer's spot in the (unscaled) frame. */
    #setOrigin(image, event) {
      const box = image.parentElement.getBoundingClientRect();
      const x = ((event.clientX - box.left) / box.width) * 100;
      const y = ((event.clientY - box.top) / box.height) * 100;
      image.style.transformOrigin = `${x}% ${y}%`;
    }

    #onClose = () => {
      for (const image of this.querySelectorAll('.is-zoomed')) image.classList.remove('is-zoomed');
      this.#opener?.focus({ preventScroll: true });
      this.#opener = null;
    };
  }

  if (!customElements.get('product-lightbox')) customElements.define('product-lightbox', ProductLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welcome-popup"] && !Shopify.designMode) return;
  try {
    /**
   * Opens the welcome sheet once: after the delay, when nothing else is on screen.
   * Remembers { state: 'seen' | 'subscribed', at } in localStorage; without storage
   * it stays closed rather than opening on every page.
   */
  class WelcomePopup extends HTMLElement {
    static key = 'morrow:welcome';

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.dialog.addEventListener('click', this.#onClick);

      const params = new URLSearchParams(window.location.search);
      const posted = params.get('customer_posted') === 'true';
      const ours = window.location.hash === `#${this.dataset.formId}`;

      // back from our own form: the thank-you, or the form with Shopify's error
      if (ours) {
        if (posted) {
          this.#remember('subscribed');
          this.#showDone();
        }
        this.#open();
        return;
      }
      // signed up through another form (the footer) on this visit
      if (posted) {
        this.#remember('subscribed');
        return;
      }
      if (this.hasAttribute('data-preview')) {
        this.#open();
        return;
      }
      if (this.#recentlySeen()) return;

      const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
      this.timer = window.setTimeout(this.#openWhenClear, delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    #openWhenClear = () => {
      if (this.#screenBusy()) {
        this.timer = window.setTimeout(this.#openWhenClear, 1500);
        return;
      }
      if (this.#remember('seen')) this.#open();
    };

    // another dialog, the cookie banner, or a field being filled in
    #screenBusy() {
      if (document.querySelector('dialog[open]')) return true;
      const banner = document.getElementById('shopify-pc__banner');
      if (banner && banner.getClientRects().length > 0 && getComputedStyle(banner).visibility !== 'hidden') return true;
      return document.activeElement?.matches('input, textarea, select') ?? false;
    }

    #open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    // after a sign-up only the thank-you shows; it names the sheet for screen readers
    #showDone() {
      for (const node of this.querySelectorAll('[data-offer]')) node.hidden = true;
      this.querySelector('[data-done]').hidden = false;
      this.dialog.setAttribute('aria-labelledby', 'WelcomePopupDoneTitle');
    }

    #onClick = (event) => {
      if (event.target === this.dialog || event.target.closest('[data-close]')) this.dialog.close();
    };

    #read() {
      try {
        return JSON.parse(window.localStorage.getItem(WelcomePopup.key) || 'null');
      } catch {
        return null;
      }
    }

    #recentlySeen() {
      const saved = this.#read();
      if (!saved) return false;
      if (saved.state === 'subscribed') return true;
      const days = Number(this.dataset.days) || 14;
      return Date.now() - Number(saved.at) < days * 86400000;
    }

    // true when the choice was stored; a browser without storage never sees the sheet
    #remember(state) {
      try {
        window.localStorage.setItem(WelcomePopup.key, JSON.stringify({ state, at: Date.now() }));
        return true;
      } catch {
        return false;
      }
    }
  }

  if (!customElements.get('welcome-popup')) customElements.define('welcome-popup', WelcomePopup);
  } catch(e) { console.error(e); }
})();

})();
